import api, {
    MutationRequestOptions,
    getMutationRequestConfig,
} from '../utils/axiosConfig'
import type {
    ProjectManagementOverview,
    SyncViewerAccountProjectsRequest,
    UpdateViewerAccountPasswordRequest,
    UpdateViewerAccountRequest,
    ViewerAccountSummary,
} from '../types/projectManagement'

export const getProjectManagementOverview = async (): Promise<ProjectManagementOverview> => {
    const response = await api.get<ProjectManagementOverview>('/project-management/overview')
    return response.data
}

export const getProjectViewerAuthorizationOverview = async (): Promise<ProjectManagementOverview> => {
    const response = await api.get<ProjectManagementOverview>(
        '/project-management/viewer-authorization-overview'
    )
    return response.data
}

export const updateViewerAccount = async (
    userId: number,
    payload: UpdateViewerAccountRequest,
    options?: MutationRequestOptions
): Promise<ViewerAccountSummary> => {
    const response = await api.patch<ViewerAccountSummary>(
        `/project-management/viewer-accounts/${userId}`,
        payload,
        getMutationRequestConfig(options)
    )
    return response.data
}

export const updateViewerAccountPassword = async (
    userId: number,
    payload: UpdateViewerAccountPasswordRequest,
    options?: MutationRequestOptions
): Promise<void> => {
    await api.patch(
        `/project-management/viewer-accounts/${userId}/password`,
        payload,
        getMutationRequestConfig(options)
    )
}

export const syncViewerAccountProjects = async (
    userId: number,
    payload: SyncViewerAccountProjectsRequest,
    options?: MutationRequestOptions
): Promise<void> => {
    await api.put(
        `/project-management/viewer-accounts/${userId}/projects`,
        payload,
        getMutationRequestConfig(options)
    )
}
